import React from 'react';

const MobileIcon: React.FC = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.25 3.5C4.25 2.39543 5.14543 1.5 6.25 1.5H12.75C13.8546 1.5 14.75 2.39543 14.75 3.5V14.5C14.75 15.6046 13.8546 16.5 12.75 16.5H6.25C5.14543 16.5 4.25 15.6046 4.25 14.5V3.5Z"
      stroke="#171D23"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="9.5" cy="13.5" r="0.75" fill="#171D23" />
  </svg>
);

export default MobileIcon;
